module.exports = new __parcel__URL__("apply_c_faq_expanded_zh-cn.38d8b667.webp").toString();